module.exports = __webpack_public_path__ + "media/images/pic/saska/polygon_news_smaller_bg-4fce61779aeb00ba1a94dc6eb8f675c9.png";